module.exports = __webpack_public_path__ + "6f692492e1876e82e64d25d80c323c5f.pdf";